import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { EditModeContextWithOriginalState } from '../../../types';
import { getLocationStatus } from '../../util/stripe.utils';

type CellParams = ICellRendererParams & {
  isEditing: () => boolean;
  isSaving: () => boolean;
  editContext: () => EditModeContextWithOriginalState;
};

@Component({
  selector: 'app-cell-subscriptions-status',
  imports: [UiModule, NgSelectModule, FormsModule],
  templateUrl: './cell-subscriptions-status.component.html',
  styleUrl: './cell-subscriptions-status.component.scss',
})
export class CellSubscriptionsStatusComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  public readonly locationStatuses = [
    { name: 'Default', value: 'default' },
    { name: 'Reviewable', value: 'Reviewable' },
    { name: 'CameraInstalled', value: 'CameraInstalled' },
  ];

  public getLocationStatus = getLocationStatus;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
